import script from "./footerCom.vue?vue&type=script&setup=true&lang=js"
export * from "./footerCom.vue?vue&type=script&setup=true&lang=js"

import "./footerCom.vue?vue&type=style&index=0&id=b23884d4&lang=css"

const __exports__ = script;

export default __exports__